/**
 * This mixin adds computed properties that are used by all full-slide TEIs.
 */

import { mapState } from 'pinia';
import {
  useAssessmentStore,
} from '@/stores';

export default {
  props: {
    assetId: {
      type: String,
      required: true,
    },
    mode: {
      type: String,
      default: null,
    },
    scale: {
      type: Number,
      default: 1,
    },
    isDisplayed: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showFeedback: false,
      submittingAttempt: false,
    };
  },
  computed: {
    ...mapState(useAssessmentStore, [
      'attempt',
      'teis',
      'attemptItemByTeiId',
      'teiLang',
      'userCanEditAttempt',
    ]),
    attemptItemTry() {
      return this.attemptItemByTeiId(this.assetId)?.try || {};
    },
    maxScore() {
      // TEI data stores max score as a string
      return parseInt(this.teiData.scoringData?.maxScore, 10);
    },
    teiData() {
      return this.teis[this.assetId];
    },
    tries() {
      return this.attemptItemTry.tries || 0;
    },
  },
};
